import { Location as AngularLocation } from '@angular/common';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { SupportWorkspaceDialogComponent } from './support-workspace.dialog';

@Component({
  selector: 'app-support-page',

  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class SupportPage implements OnInit {
  private location = inject(AngularLocation);
  private modalCtrl = inject(ModalController);
  private router = inject(Router);

  async ngOnInit() {
    const existingModal = await this.modalCtrl.getTop();
    if (existingModal) {
      return;
    }

    const modal = await this.modalCtrl.create({
      component: SupportWorkspaceDialogComponent,
      cssClass: ['workspace-modal', 'stack-modal', 'support-workspace-modal'],
    });

    modal.onDidDismiss().then(() => {
      if (this.router.url === '/support') {
        if (window.history.length > 1) {
          this.location.back();
          return;
        }

        this.router.navigateByUrl('/home');
      }
    });

    await modal.present();
  }
}
